import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * checkboxチェッククラス
 */
export default class EFOcats_validate_checkbox extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'checkbox') {
      return new EFOcats_error_info('success', '', '', '');
    }

    let result = new EFOcats_error_info('success', '', '', '');

    if (checkData.parents('.qa').find('input:checked').length > 0) {
      result = new EFOcats_error_info('success', '', '', '');
    } else if (checkData.parents('.qa').find('input:checked').length <= 0) {
      result = new EFOcats_error_info('error', this.langagerList('未選択エラー'), '', '未選択エラー');
    }

    if (!checkData.parents('.container').hasClass('required')) {
      result.status = 'success';
    }

    return result;
  }
}
